"use client";

import { useLocale as useLocaleFromUtils } from "./useLocale";

/**
 * Hook to get current text direction (ltr/rtl) from locale
 * For Web components only - uses URL locale
 * For Hub components, use useLocale from @/Hub/Stores/useLocale
 */
export function useDirection(): "ltr" | "rtl" {
  const locale = useLocaleFromUtils() as UILocale;
  return locale === "he" ? "rtl" : "ltr";
}

/**
 * Utility function to get direction synchronously (for non-hook usage)
 * @deprecated Use direction from useLocale store or compute from locale
 */
export function getDirection(): "ltr" | "rtl" {
  if (typeof document === "undefined") return "ltr";

  const htmlDir = document.documentElement.dir;
  if (htmlDir === "rtl" || htmlDir === "ltr") {
    return htmlDir;
  }

  const bodyDir = document.body.getAttribute("data-direction");
  if (bodyDir === "rtl" || bodyDir === "ltr") {
    return bodyDir;
  }

  return "ltr";
}
